import { messstelle, kenngroesse } from './../../../utils/apiTypes';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../../../app/store";
import { colNameType, pqIndexResult, uwZeitPqIndex } from "./pqIndexTypes";
import { postJsonWithAuth } from "../../../utils/api";
import { logError, convertDateToWeekNumber } from "../../../utils/utils";
import { errorHandler } from '../../../utils/errorHandling';

const initialState: uwZeitPqIndex
  = {
  uw_zeitListe: [],
  uwZeit: [],
  uw_MinUW: [],
  zeit_MinUw: [],
  zeit_MinZeit: [],
  minUwZeitAll: 10,
  loadingUwZeit: false,
}

const uwZeitPqIndexSlice = createSlice({
  name: "uwZeitPqIndex",
  initialState,
  reducers:
  {
    setUw_zeitListe: (state, action: PayloadAction<colNameType[]>) => {
      state.uw_zeitListe = action.payload;
    },
    setZeitMinUWListe: (state, action: PayloadAction<number>) => {
      state.zeit_MinUw.push(action.payload);
    },
    emptyZeitMinUwListe: (state) => {
      state.zeit_MinUw = [];
    },
    setZeitMinZeitListe: (state, action: PayloadAction<number>) => {
      state.zeit_MinZeit.push(action.payload);
    },
    emptyZeitMinZeitListe: (state) => {
      state.zeit_MinZeit = [];
    },
    setMinUWZeitAll: (state, action: PayloadAction<number>) => {
      state.minUwZeitAll = action.payload;
    },
    setUwZeit: (state, action: PayloadAction<Array<Array<pqIndexResult>>>) => {
      state.uwZeit = action.payload;
    },
    setLoadingUwZeit: (state, action: PayloadAction<boolean>) => {
      state.loadingUwZeit = action.payload;
    },
  }
});

export const selectUWZeitListe = (state: RootState): colNameType[] => state.uwZeitPqIndex.uw_zeitListe;
export const selectUwMinUwListe = (state: RootState): number[] => state.uwZeitPqIndex.uw_MinUW;
export const selectZeitMinUwListe = (state: RootState): number[] => state.uwZeitPqIndex.zeit_MinUw;
export const selectZeitMinZeitListe = (state: RootState): number[] => state.uwZeitPqIndex.zeit_MinZeit
export const selectUWMinZeitAll = (state: RootState): number => state.uwZeitPqIndex.minUwZeitAll;
export const selectUwZeit = (state: RootState): pqIndexResult[][] => state.uwZeitPqIndex.uwZeit;
export const selectLoadingUwZeit = (state: RootState): boolean => state.uwZeitPqIndex.loadingUwZeit;


export const getUwZeit =
  (messstelleParam: Array<messstelle>, kenngroesseParam: Array<kenngroesse>, startParam: Date, endeParam: Date, pqIndexMinParam: number, pqIndexMaxParam: number, grenzwertsatz: string, grupByUWParam: boolean) => (
    dispatch: AppDispatch): void => {

    const body = {
      start: startParam,
      end: endeParam,
      kenngroessen: kenngroesseParam,
      messstellen: messstelleParam,
      pqIndexMin: pqIndexMinParam,
      pqIndexMax: pqIndexMaxParam,
      grenzwertsatzName: grenzwertsatz
    }

    dispatch(setLoadingUwZeit(true))
    postJsonWithAuth("PQINDEXMESSSTELLEZEIT", { groupByUw: grupByUWParam }, body)
      .then((response: Array<Array<pqIndexResult>>) => {
        dispatch(emptyZeitMinZeitListe());
        dispatch(emptyZeitMinUwListe());
        dispatch(setUwZeit(response))
        const kwList: Array<colNameType> = [];
        let tempMinUwAll = 10;
        let tempMinZeitAll = 10;

        response.forEach(rows => {
          let tempMin = rows[0].value === null || rows[0].value === undefined ? 10 : rows[0].value;
          rows.forEach(row => {
            const dateTemp: Date = new Date(row.col);
            const convertWeekNumber = convertDateToWeekNumber(dateTemp)
            const yearOfWeekNumber = dateTemp.getFullYear();
            const colElem: colNameType = { name: convertWeekNumber.toString().length > 1 ? "KW " + "(" + yearOfWeekNumber + ") " + convertWeekNumber : "KW " + "(" + yearOfWeekNumber + ") " + "0" + convertWeekNumber, col: row.col }
            kwList.push(colElem)
            if (row.value !== null && row.value !== undefined) {
              if (tempMin > row.value) {
                tempMin = row.value
              }
            }
          })
          dispatch(setZeitMinUWListe(tempMin))
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinUwAll > tempMin) {
              tempMinUwAll = tempMin;
            }
          }
        })

        kwList.sort((a, b) => a.name.localeCompare(b.name))
        const filterdKwList: Array<colNameType> = kwList.filter(function (elem, pos, self) {
          return self.findIndex((x) => (
            x.name === elem.name && x.col === elem.col
          )) == pos
        })


        filterdKwList.forEach(zeitElem => {
          const initData = response[0][0];
          let tempMin = 11;
          const dateTempInit = initData.col;
          if (zeitElem.col == dateTempInit) {
            tempMin = initData.value;
          }
          response.forEach(rows => {
            rows.forEach(row => {
              const dateTempCol = row.col;
              if (zeitElem.col == dateTempCol) {
                if (row.value !== null && row.value !== undefined) {
                  if (tempMin > row.value) {
                    tempMin = row.value
                  }
                }
              }
            })
          })
          dispatch(setZeitMinZeitListe(tempMin));
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinZeitAll > tempMin) {
              tempMinZeitAll = tempMin;
            }
          }
        })

        dispatch(setUw_zeitListe(filterdKwList));
        dispatch(setMinUWZeitAll(tempMinUwAll < tempMinZeitAll ? tempMinUwAll : tempMinZeitAll))


      })
      .catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
      }).finally(() => dispatch(setLoadingUwZeit(false)));
  };

export const {
  setUw_zeitListe,
  setMinUWZeitAll,
  setZeitMinUWListe,
  emptyZeitMinUwListe,
  setZeitMinZeitListe,
  emptyZeitMinZeitListe,
  setUwZeit,
  setLoadingUwZeit
} = uwZeitPqIndexSlice.actions;

export default uwZeitPqIndexSlice.reducer;